import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider } from "@/context/AuthContext";
import { SiteProvider } from "@/context/SiteContext";
import ThemeInjector from "@/components/ThemeInjector";
import Landing from "@/pages/Landing";
import Login from "@/pages/Login";
import Admin from "@/pages/Admin";

function App() {
  return (
    <div className="App grain">
      <AuthProvider>
        <SiteProvider>
          <ThemeInjector />
          <BrowserRouter>
            <ReactLenis root options={{ lerp: 0.085, smoothWheel: true, wheelMultiplier: 1 }}>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/login" element={<Login />} />
                <Route path="/admin" element={<Admin />} />
              </Routes>
            </ReactLenis>
          </BrowserRouter>
          <Toaster position="top-center" theme="dark" richColors />
        </SiteProvider>
      </AuthProvider>
    </div>
  );
}

export default App;
